import Page from "webPage/Page";

Page.register('page-template-contact', () => {
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId === 1) {
            $('.js-form-heading').hide();
            try {
                dataLayer.push({'event': 'submit_contact'});
            } catch (e) {
                console.log(e);
            }
        }
    });
});
